import { useTranslation } from 'react-i18next';
import { AddressBook } from '@phosphor-icons/react';

import { List, NoResultsMessage, Section, Spacer } from 'theSource/components';
import { Contact } from 'theSource/features/Contacts/types';
import { mapItems } from './utils';

export interface ContactsListProps {
  content?: JSX.Element;
  contacts: Contact[];
  name: string;
  testId: string;
  displayEmptyListMessage?: boolean;
}

export const ContactsList = ({
  content = <></>,
  contacts,
  name,
  testId,
  displayEmptyListMessage = false,
}: ContactsListProps) => {
  const { t } = useTranslation('pages.contacts');

  if (!contacts.length && !displayEmptyListMessage) {
    return <></>;
  }

  return (
    <Section key={name} name={name} testId={testId}>
      {content}
      <>
        {!contacts.length && displayEmptyListMessage ? (
          <>
            <Spacer height={8} />
            <NoResultsMessage
              IconComponent={AddressBook}
              message={t('noSavedContacts')}
              testId="no-contacts-message"
            />
          </>
        ) : (
          <List
            items={mapItems(contacts)}
            isCombined={false}
            spacing={4}
            valueHolderVariant="body1"
          />
        )}
      </>
    </Section>
  );
};
